// @flow
import React from 'react';
import { Well } from 'dibs-elements/exports/Well';
import Close from 'dibs-vg/dist/react/close';
import styles from './styles/loginCommon.scss';
import { FormattedMessage } from 'react-intl';

type CookieDisclaimerProps = {
    dismissDisclaimer: () => mixed,
    shouldDisplayCookieDisclaimer: boolean,
};

const CookieDisclaimer = ({
    shouldDisplayCookieDisclaimer,
    dismissDisclaimer,
}: CookieDisclaimerProps) => {
    if (!shouldDisplayCookieDisclaimer) {
        return null;
    }
    return (
        <div className={styles.diclaimerContainer}>
            <Well className={styles.disclaimerWell}>
                <div className={styles.disclaimerContentContainer}>
                    <div>
                        <FormattedMessage
                            id="cookieDisclaimer.notice"
                            defaultMessage="1stdibs uses cookies to ensure you get the best experience on our website. By continuing to browse, you agree to our {cookiePolicy}."
                            values={{
                                cookiePolicy: (
                                    <a href="https://support.1stdibs.com/s/article/Cookie-Policy">
                                        <FormattedMessage
                                            id="cookieDisclaimerLinkedText"
                                            defaultMessage="cookie policy"
                                        />
                                    </a>
                                ),
                            }}
                        />
                    </div>
                    <div className={styles.disclaimerCloseButton} onClick={dismissDisclaimer}>
                        <Close />
                    </div>
                </div>
            </Well>
        </div>
    );
};
export default CookieDisclaimer;
